import { type StoryblokProductSearchFiltersType } from '../StoryblokProductSearchFilters.types'

import { storyblokProductSearchFiltersParseBooleanToQueryString } from './storyblokProductSearchFiltersParseBooleanToQueryString'
import { storyblokProductSearchFiltersParsePromotionIdToQueryString } from './storyblokProductSearchFiltersParsePromotionIdToQueryString'
import { storyblokProductSearchFiltersParseRangeFilterToQueryString } from './storyblokProductSearchFiltersParseRangeFilterToQueryString'
import { storyblokProductSearchFiltersParseStringArrayToQueryString } from './storyblokProductSearchFiltersParseStringArrayToQueryString'

export type StoryblokProductSearchFilterToQueryMapperType = {
  [key in keyof Required<StoryblokProductSearchFiltersType>]: (
    fieldName: string,
    values: Required<StoryblokProductSearchFiltersType>[key],
  ) => string | null
}

/**
 * Maps each supported product search filter key to a function that converts its
 * filters into a query string.
 *
 * Example:
 *   Input filters object:
 *     {
 *       categoryCodes: ['shoes', 'bags'],
 *       brandCode: ['nike', 'adidas'],
 *       discountInPercent: { min: 20, max: 50 }
 *     }
 *   Output query string:
 *     {
 *       categoryCodes: 'categoryCodes:shoes OR categoryCodes:bags',
 *       brandCode: 'brandCode:nike OR brandCode:adidas',
 *       discountInPercent: 'discountInPercent >= 20 AND discountInPercent <= 50'
 *     }
 */
export const STORYBLOK_PRODUCT_SEARCH_FILTERS_TO_QUERY_MAPPER: StoryblokProductSearchFilterToQueryMapperType =
  {
    brandCode: storyblokProductSearchFiltersParseStringArrayToQueryString,
    categoryCodes: storyblokProductSearchFiltersParseStringArrayToQueryString,
    created: storyblokProductSearchFiltersParseRangeFilterToQueryString,
    discountInPercent:
      storyblokProductSearchFiltersParseRangeFilterToQueryString,
    nowProductGroup: storyblokProductSearchFiltersParseStringArrayToQueryString,
    prescriptionMedicine:
      storyblokProductSearchFiltersParseBooleanToQueryString,
    promotion: storyblokProductSearchFiltersParseStringArrayToQueryString,
    promotionId: storyblokProductSearchFiltersParsePromotionIdToQueryString,
    ribbonText: storyblokProductSearchFiltersParseStringArrayToQueryString,
    RPEndDate: storyblokProductSearchFiltersParseRangeFilterToQueryString,
    RPMultiplier: storyblokProductSearchFiltersParseRangeFilterToQueryString,
    RPStartDate: storyblokProductSearchFiltersParseRangeFilterToQueryString,
    stockStatusReason:
      storyblokProductSearchFiltersParseStringArrayToQueryString,
  }
